import { strFromU8 } from 'fflate';

// Entry names: decoding and the path rules an archive must keep.

// Code page 437, which ZIP assumes for names without the UTF-8 flag.
const CP437_HIGH =
  'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀'
  + 'αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ';

function isValidUtf8(bytes: Uint8Array): boolean {
  let i = 0;
  while (i < bytes.length) {
    const b = bytes[i];
    let extra: number;
    if (b < 0x80) extra = 0;
    else if (b >= 0xc2 && b <= 0xdf) extra = 1;
    else if (b >= 0xe0 && b <= 0xef) extra = 2;
    else if (b >= 0xf0 && b <= 0xf4) extra = 3;
    else return false;
    if (i + extra > bytes.length - 1) return false;
    for (let k = 1; k <= extra; k += 1) if ((bytes[i + k] & 0xc0) !== 0x80) return false;
    i += extra + 1;
  }
  return true;
}

export function decodeEntryName(bytes: Uint8Array, utf8Flag: boolean): string {
  if (utf8Flag || isValidUtf8(bytes)) return strFromU8(bytes);
  let out = '';
  for (const b of bytes) out += b < 0x80 ? String.fromCharCode(b) : CP437_HIGH[b - 0x80];
  return out;
}

/**
 * A name is used as given, never joined to a device path, but it is still the
 * archive's claim about its own layout. Anything that could mean "outside the
 * archive" or two names for one place makes the whole archive untrusted.
 */
export function unsafeNameReason(name: string): string | null {
  if (!name) return 'empty';
  if (/[\u0000-\u001f\u007f]/.test(name)) return 'control_character';
  if (name.includes('\\')) return 'backslash';
  if (name.startsWith('/')) return 'absolute';
  if (/^[A-Za-z]:/.test(name)) return 'drive';
  const parts = name.replace(/\/$/, '').split('/');
  if (parts.some((part) => part === '' || part === '.' || part === '..')) return 'traversal';
  return null;
}
